import script from "./Paypal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paypal.vue?vue&type=script&setup=true&lang=ts"

import "./Paypal.vue?vue&type=style&index=0&id=586db622&scoped=true&lang=css"
script.__scopeId = "data-v-586db622"

export default script